module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"email":"Email","new email":"New email","discard":"Discard","change":"Change"},"de":{"email":"Email","new email":"Neue Email","discard":"Verwerfen","change":"Ändern"}}')
  delete Component.options._Ctor
}
